import { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { Box, Tooltip, IconButton, InputBase, Typography } from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseRelatedArticle } from "./UseRelatedArticle";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import DeleteRow from "../../components/DeleteRow";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";

function RelatedArticle() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const navigate = useNavigate();
  const { getRelatedList, deleteRelated } = UseRelatedArticle();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC("MasterArticleId");
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [RelatedRes, setBrandRes] = useState();
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getRelatedList(
      myPc,
      search,
      (relateds) => {
        if (msGotoLast) {
          setMsGotoLast(false);
          goToLastPage(relateds.pageCondition.totalPage);
          return;
        }
        setBrandRes(relateds);
      },
      true
    );
  }, [myPc]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const newFunc = () => {
    return navigate("/relatedarticle/addRelatedArticle", {
      state: {
        myPc: myPc,
        search: search,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 70,
      headerName: "ID",
      align: "center",
      hide: true,
      headerAlign: "center",
    },

    {
      field: "masterArticleId",
      width: 100,
      headerName: "کد مستر",
      align: "center",
      headerAlign: "center",
    },
    {
      field: "articleName",
      headerName: " نام مقاله مستر ",
      width: 280,
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.articleName}
          </Typography>
        );
      },
    },
    {
      field: "slaveArticleId",
      width: 100,
      headerName: "کد اسلیو",
      align: "center",
      headerAlign: "center",
    },
    {
      field: "slaveArticleName",
      headerName: "نام مقاله اسلیو",
      width: 280,
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.slaveArticleName}
          </Typography>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 100,
      align: "center",
      headerAlign: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box>
            <Tooltip title="Delete">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.faName,
                    model: {
                      id: cellValues.row.id,
                      masterArticleId: cellValues.row.masterArticleId,
                      slaveArticleId: cellValues.row.slaveArticleId,
                    },
                  });
                }}
              >
                <DeleteIcon sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "مدیریت محتوا",
        childs: [{ name: msActiveMenu.pageTitle, url: "/relatedarticle" }],
      }}
    >
      {RelatedRes ? (
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={RelatedRes.pageCondition.pageCount}
          rows={RelatedRes.articles}
          paginationMode="server"
          page={RelatedRes.pageCondition.page - 1}
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={
            RelatedRes?.pageCondition.totalItemCount
              ? RelatedRes.pageCondition.totalItemCount
              : 1
          }
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              scrollTo: myPc.scrollTo,
              isLtr: true,
              newFunc: newFunc,
              rowCount: RelatedRes?.pageCondition.totalItemCount
                ? RelatedRes.pageCondition.totalItemCount
                : "",
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPc.sortColumn),
                  sort: deCapitalizeFirstLetter(myPc.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPc.page,
            },
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"مقاله مرتبط"}
        callback={() => {
          setProgress(true);
          deleteRelated(deleteState.model, () => {
            refresh();
          });
        }}
      ></DeleteRow>
    </Detail>
  );
}

export default RelatedArticle;
